<template>
  <section class="mt-10">
    <div class="bg-white dark:bg-gray-800 relative shadow-md sm:rounded-lg overflow-hidden">
      <div class="border-b dark:border-gray-700 mx-4">
        <div class="flex items-center justify-between space-x-4 pt-3">
          <div class="flex-1 flex items-center space-x-3">
            <h5 class="dark:text-white font-semibold">
              All Courses
            </h5>
          </div>
        </div>
        <div class="flex flex-col-reverse md:flex-row items-center justify-between md:space-x-4 py-3">
          <div class="w-full lg:w-2/3 flex flex-col space-y-3 md:space-y-0 md:flex-row md:items-center">
            <form class="w-full md:max-w-sm flex-1 md:mr-4">
              <label
                class="text-sm font-medium text-gray-900 sr-only dark:text-white"
                for="course-search"
              >Search</label>
              <input
                id="course-search"
                v-model="searchQuery"
                class="block w-full p-2 pl-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                placeholder="Search..."
                type="search"
              >
            </form>
          </div>
          <div
            class="w-full md:w-auto flex flex-col md:flex-row mb-3 md:mb-0 items-stretch md:items-center justify-end md:space-x-3 flex-shrink-0"
          >
            <button
              class="flex items-center justify-center text-white bg-black hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800"
              type="button"
              @click="openModal('newCourse')"
            >
              <svg
                class="h-3.5 w-3.5 mr-2"
                fill="none"
                height="12"
                viewBox="0 0 12 12"
                width="12"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 0.75V11.25M0.75 6H11.25"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                />
              </svg>
              Add New Course
            </button>
            <Modal
              :is-visible="modals.newCourse"
              modal-id="newCourse"
              @update:is-visible="value => modals.newCourse = value"
            >
              <template #body>
                <div class="p-4">
                  <div class="flex flex-col items-center justify-center">
                    <svg
                      class="w-52"
                      fill="none"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g
                        id="SVGRepo_bgCarrier"
                        stroke-width="0"
                      />
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <g id="SVGRepo_iconCarrier">
                        <path
                          d="M12.5518 8C11.9995 8 11.5518 8.44772 11.5518 9C11.5518 9.55228 11.9995 10 12.5518 10H16.5518C17.104 10 17.5518 9.55228 17.5518 9C17.5518 8.44772 17.104 8 16.5518 8H12.5518Z"
                          fill="#000000"
                          fill-opacity="0.5"
                        />
                        <path
                          d="M12.5518 17C11.9995 17 11.5518 17.4477 11.5518 18C11.5518 18.5523 11.9995 19 12.5518 19H16.5518C17.104 19 17.5518 18.5523 17.5518 18C17.5518 17.4477 17.104 17 16.5518 17H12.5518Z"
                          fill="#000000"
                          fill-opacity="0.5"
                        />
                        <path
                          d="M12.5518 5C11.9995 5 11.5518 5.44772 11.5518 6C11.5518 6.55228 11.9995 7 12.5518 7H20.5518C21.104 7 21.5518 6.55228 21.5518 6C21.5518 5.44772 21.104 5 20.5518 5H12.5518Z"
                          fill="#000000"
                          fill-opacity="0.8"
                        />
                        <path
                          d="M12.5518 14C11.9995 14 11.5518 14.4477 11.5518 15C11.5518 15.5523 11.9995 16 12.5518 16H20.5518C21.104 16 21.5518 15.5523 21.5518 15C21.5518 14.4477 21.104 14 20.5518 14H12.5518Z"
                          fill="#000000"
                          fill-opacity="0.8"
                        />
                        <path
                          d="M3.44824 4.00208C2.89596 4.00208 2.44824 4.44979 2.44824 5.00208V10.0021C2.44824 10.5544 2.89596 11.0021 3.44824 11.0021H8.44824C9.00053 11.0021 9.44824 10.5544 9.44824 10.0021V5.00208C9.44824 4.44979 9.00053 4.00208 8.44824 4.00208H3.44824Z"
                          fill="#000000"
                        />
                        <path
                          d="M3.44824 12.9979C2.89596 12.9979 2.44824 13.4456 2.44824 13.9979V18.9979C2.44824 19.5502 2.89596 19.9979 3.44824 19.9979H8.44824C9.00053 19.9979 9.44824 19.5502 9.44824 18.9979V13.9979C9.44824 13.4456 9.00053 12.9979 8.44824 12.9979H3.44824Z"
                          fill="#000000"
                        />
                      </g>
                    </svg>
                    <h2 class="block text-2xl font-bold text-gray-800 dark:text-gray-200">
                      Create New Course
                    </h2>
                    <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">
                      You are about to create a new course.
                    </p>
                  </div>
                  <div class="relative mt-6">
                    <input
                      id="newCourseTitle"
                      v-model="newCourse.title"
                      class="peer p-4 block w-full border border-gray-200 rounded-lg text-sm placeholder:text-transparent focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 focus:pt-6 focus:pb-2 [&:not(:placeholder-shown)]:pt-6 [&:not(:placeholder-shown)]:pb-2 autofill:pt-6 autofill:pb-2"
                      placeholder="Course title"
                      type="text"
                    >
                    <label
                      class="absolute top-0 start-0 p-4 h-full text-sm truncate pointer-events-none transition ease-in-out duration-100 border border-transparent dark:text-white peer-disabled:opacity-50 peer-disabled:pointer-events-none peer-focus:text-xs peer-focus:-translate-y-1.5 peer-focus:text-gray-500 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:-translate-y-1.5 peer-[:not(:placeholder-shown)]:text-gray-500"
                      for="newCourseTitle"
                    >
                      Course Title
                    </label>
                  </div>
                  <div class="relative mt-4 mb-2">
                    <textarea
                      v-model="newCourse.description"
                      class="py-3 px-4 block w-full border border-gray-200 rounded-lg text-sm focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600"
                      placeholder="Please describe this course..."
                      rows="3"
                    />
                  </div>
                </div>
              </template>
              <template #footer>
                <div class="flex items-center">
                  <button
                    class="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-es-xl border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:hover:bg-white/20 dark:text-white dark:hover:text-white dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                    type="button"
                    @click="closeModal('newCourse')"
                  >
                    Cancel
                  </button>
                  <button
                    class="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-ee-xl border border-transparent bg-black text-white hover:bg-gray-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                    type="button"
                    @click="createCourse"
                  >
                    Create
                  </button>
                </div>
              </template>
            </Modal>
          </div>
        </div>
      </div>
      <div class="overflow-x-auto">
        <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
          <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th
                class="p-4"
                scope="col"
              >
                <div class="flex items-center">
                  <input
                    id="checkbox-all"
                    class="w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 dark:focus:ring-primary-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    type="checkbox"
                  >
                  <label
                    class="sr-only"
                    for="checkbox-all"
                  >checkbox</label>
                </div>
              </th>
              <th
                class="px-4 py-3"
                scope="col"
              >
                Course
              </th>
              <th
                class="px-4 py-3"
                scope="col"
              >
                Status
              </th>
              <th
                class="px-4 py-3"
                scope="col"
              >
                Modules
              </th>
              <th
                class="px-4 py-3"
                scope="col"
              >
                <span class="sr-only">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(course, index) in filteredCourses"
              :key="index"
              class="border-b dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              <td class="px-4 py-2 w-4">
                <div class="flex items-center">
                  <input
                    id="checkbox-table-search-1"
                    class="w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 dark:focus:ring-primary-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    type="checkbox"
                  >
                  <label
                    class="sr-only"
                    for="checkbox-table-search-1"
                  >checkbox</label>
                </div>
              </td>
              <th
                class="px-4 py-2 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                scope="row"
              >
                <router-link :to="`/administrator/courses/course/${course._id}`">
                  {{ course.title }}
                </router-link>
              </th>
              <td class="px-4 py-2 whitespace-nowrap">
                <span
                  class="bg-green-400 text-white text-xs font-medium px-2.5 py-0.5 rounded dark:bg-primary-900 dark:text-primary-300"
                >Live</span>
              </td>
              <td class="px-4 py-2 whitespace-nowrap">
                <div class="flex -space-x-4 w-28">
                  {{ course.modules.length }} modules
                </div>
              </td>
              <td class="px-4 py-2 flex justify-end">
                <router-link
                  :to="`/administrator/courses/course/${course._id}`"
                  class="flex items-center justify-center w-full px-3 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg md:w-auto focus:outline-none hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                  type="button"
                >
                  <svg
                    class="w-5 h-5 mr-2"
                    fill="#000000"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      id="SVGRepo_bgCarrier"
                      stroke-width="0"
                    />
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <g id="SVGRepo_iconCarrier">
                      <title />
                      <g id="Complete">
                        <g id="edit">
                          <g>
                            <path
                              d="M20,16v4a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V6A2,2,0,0,1,4,4H8"
                              fill="none"
                              stroke="#000000"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                            />
                            <polygon
                              fill="none"
                              points="12.5 15.8 22 6.2 17.8 2 8.3 11.5 8 16 12.5 15.8"
                              stroke="#000000"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <span>Edit Course</span>
                </router-link>
                <button
                  class="flex items-center justify-center w-full ml-2 px-3 py-2 text-sm font-medium text-red-500 bg-white border border-red-400 rounded-lg md:w-auto focus:outline-none hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                  type="button"
                >
                  <svg
                    class="w-5 h-5 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      id="SVGRepo_bgCarrier"
                      stroke-width="0"
                    />
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M4 7H20"
                        stroke="#ff5c5c"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                      <path
                        d="M6 10L7.70141 19.3578C7.87432 20.3088 8.70258 21 9.66915 21H14.3308C15.2974 21 16.1257 20.3087 16.2986 19.3578L18 10"
                        stroke="#ff5c5c"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                      <path
                        d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
                        stroke="#ff5c5c"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                    </g>
                  </svg>
                  <span>Delete</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <nav
        aria-label="Table navigation"
        class="flex flex-col md:flex-row justify-between items-start md:items-center space-y-3 md:space-y-0 p-4"
      >
        <span class="text-sm font-normal text-gray-500 dark:text-gray-400"> Showing <span
          class="font-semibold text-gray-900 dark:text-white"
        >1-10</span> of <span
          class="font-semibold text-gray-900 dark:text-white"
        >{{ courses.length }}</span> </span>
        <ul class="inline-flex items-stretch -space-x-px">
          <li>
            <a
              class="flex items-center justify-center h-full py-1.5 px-3 ml-0 text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              href="#"
            >
              <span class="sr-only">Previous</span>
              <svg
                aria-hidden="true"
                class="w-5 h-5"
                fill="currentColor"
                viewbox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clip-rule="evenodd"
                  d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                  fill-rule="evenodd"
                />
              </svg>
            </a>
          </li>
          <li>
            <a
              class="flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              href="#"
            >0</a>
          </li>
          <li>
            <a
              aria-current="page"
              class="flex items-center justify-center text-sm z-10 py-2 px-3 leading-tight text-primary-600 bg-primary-50 border border-primary-300 hover:bg-primary-100 hover:text-primary-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white"
              href="#"
            >1</a>
          </li>
          <li>
            <a
              class="flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              href="#"
            >...</a>
          </li>
          <li>
            <a
              class="flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              href="#"
            >1</a>
          </li>
          <li>
            <a
              class="flex items-center justify-center h-full py-1.5 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              href="#"
            >
              <span class="sr-only">Next</span>
              <svg
                aria-hidden="true"
                class="w-5 h-5"
                fill="currentColor"
                viewbox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clip-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  fill-rule="evenodd"
                />
              </svg>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </section>
</template>
<script lang="ts">
import {defineComponent, onMounted, ref, watch, watchEffect} from 'vue';
import axios from 'axios';
import {useRouter} from 'vue-router';
import Modal from '@/components/Modal.vue';
import {Course} from '@/types';
import {useHead} from "@vueuse/head";

export default defineComponent({
  name: 'Courses',
  components: {
    Modal
  },
  setup() {
    const router = useRouter();
    const courses = ref<Course[]>([]);
    const filteredCourses = ref<Course[]>([]);
    const loading = ref(false);
    const error = ref<string | null>(null);
    const searchQuery = ref('');
    const newCourse = ref({title: '', description: ''});
    const modals = ref<Record<string, boolean>>({});

    watchEffect(() => {
      useHead({
        title: 'Courses',
      });
    });

    const filterCourses = () => {
      if (searchQuery.value.trim() === '') {
        filteredCourses.value = courses.value;
      } else {
        filteredCourses.value = courses.value.filter((course) =>
            course.title.toLowerCase().includes(searchQuery.value.toLowerCase())
        );
      }
    };

    const openModal = (modalId: string) => {
      modals.value[modalId] = true;
    };

    const closeModal = (modalId: string) => {
      modals.value[modalId] = false;
    };

    const createCourse = async () => {
      try {
        const response = await axios.post<Course>('/course/create', newCourse.value);
        courses.value.push(response.data);
        filteredCourses.value = [...courses.value];
        newCourse.value = {title: '', description: ''};
        closeModal('newCourse');
        console.log('Course created successfully:', response.data);
      } catch (err) {
        console.error('Failed to create course:', err);
      }
    };

    onMounted(async () => {
      loading.value = true;
      try {
        const response = await axios.get<Course[]>('course/all');
        courses.value = response.data;
        filteredCourses.value = response.data;
      } catch (err) {
        console.error(err);
        error.value = 'An error occurred while fetching the courses.';
      } finally {
        loading.value = false;
      }
    });

    watch(searchQuery, filterCourses);

    return {
      router,
      courses,
      filteredCourses,
      loading,
      error,
      searchQuery,
      newCourse,
      modals,
      openModal,
      closeModal,
      filterCourses,
      createCourse,
    };
  },
});
</script>
